// extracted by mini-css-extract-plugin
module.exports = {"outer":"CardArtiste_outer__3BELf","cardArtistePrecis":"CardArtiste_cardArtistePrecis__37ID1","imgGrey":"CardArtiste_imgGrey__3oSys"};